import React, { useState } from "react";
import styled from "styled-components";
import { Table, Input, Row, Col } from "antd";
import { useTranslation } from "react-i18next";
import {
  useQueryParam,
  NumberParam,
  withDefault,
} from "use-query-params";

import { LIMIT_PAGE } from "constants/index";

import { SALARY_COLUMNS } from "./constants";
import { salary } from "./mock";

const Container = styled.div`
  padding: 12px;
`;

const StyledRow = styled(Row)`
  padding-bottom: 12px;
`;

const { Search } = Input;

const Salary = () => {
  const { t } = useTranslation();
  const [page, setPage] = useQueryParam("page", withDefault(NumberParam, 1));
  const [search, setSearch] = useState("");

  const salaryData = salary.filter(({ employee, job_posistion }) =>
    `${employee}_${job_posistion}`.includes(search.trim().toLowerCase()));

  return (
    <Container>
      <StyledRow>
        <Col span={4}>
          <Search
            placeholder={t("QuickSearch")}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Col>
      </StyledRow>
      <Table
        rowKey="id"
        pagination={{
          current: page,
          onChange: setPage,
          pageSize: LIMIT_PAGE,
        }}
        columns={SALARY_COLUMNS}
        dataSource={salaryData}
      />
    </Container>
  );
};

export default Salary;
